module.exports = __webpack_public_path__ + "static/media/online learning.e52d587e.png";